import { render } from "./DashboardContainer.vue?vue&type=template&id=2cc2343e"
import script from "./DashboardContainer.vue?vue&type=script&lang=js"
export * from "./DashboardContainer.vue?vue&type=script&lang=js"

import exportComponent from "/home/salih/development/sayberdata-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__